import { SxProps } from "@mui/material"
import { Theme } from "@mui/system"

export const securityList: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  gap: "16px",
  position: "relative",
  padding: "0",
}

export const securityListItem: SxProps<Theme> = {
  maxWidth: "100%",
  minHeight: "40px",
  backgroundColor: "inherit",
  transition: "all 0.3s ease",
  "@media (max-width: 756px)": {
    padding: "0",
  },
}

export const securityListButton: SxProps<Theme> = {
  display: "grid",
  gridTemplateColumns: "24px 1fr",
  width: "100%",
  height: "100%",
  gap: "12px",
  padding: "8px 16px",
  transition: "all 0.3s ease",
  cursor: "pointer",
  "&:hover,  &.Mui-selected, &.Mui-selected:hover": {
    backgroundColor: "var(--Schemes-Surface-Container-Highest)",
    transition: "all 0.3s ease",
    span: {
      color: "var(--Schemes-Primary)",
    },
    svg: {
      color: "var(--Schemes-Primary)",
    },
  },
  "&::after, &::before": {
    content: "''",
    position: "absolute",
    right: "16px",
    backgroundColor: "var(--Schemes-On-Surface)",
    height: "2px",
    width: "8.5px",
    borderRadius: "16px",
    transition: "backgroundColor 0.3s ease",
  },
  "&::after": {
    transform: "translateY(-140%) rotate(45deg)",
  },
  "&::before": {
    transform: "translateY(140%) rotate(-45deg)",
  },
  "&:hover::after, &:hover::before, &.Mui-selected::after, &.Mui-selected::before":
    {
      backgroundColor: "var(--Schemes-Primary)",
      transition: "backgroundColor 0.3s ease",
    },
}

export const securityListIcon: SxProps<Theme> = {
  color: "var(--Schemes-On-Surface)",
}

export const securityListText: SxProps<Theme> = {
  margin: 0,
  ".MuiListItemText-primary": {
    fontSize: "14px",
    fontWeight: 500,
    color: "var(--Schemes-On-Surface)",
    lineHeight: "20px",
    letterSpacing: "0.1px",
  },
  ".MuiListItemText-secondary": {
    fontSize: "11px",
    fontWeight: 500,
    color: "var(--Schemes-On-Surface-Variant)",
    lineHeight: "16px",
    overflowWrap: "anywhere",
    paddingRight: "8px",
    letterSpacing: "0.5px",
  },
}
